import { render } from "./ResetPassword.vue?vue&type=template&id=6cc1694f&scoped=true&ts=true"
import script from "./ResetPassword.vue?vue&type=script&lang=ts"
export * from "./ResetPassword.vue?vue&type=script&lang=ts"

import "./ResetPassword.vue?vue&type=style&index=0&id=6cc1694f&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\KOMEF\\vuejs-heselcare\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cc1694f"]])

export default __exports__